import { lastValueFrom } from 'rxjs';

import type { HttpResponse, HttpService } from 'portlet/common/services';
import { isUrl } from 'common/utils';

export class ThemeService {
    constructor(private readonly http: HttpService, private readonly baseUrl: string) {}

    public getThemeCss(currentStylesheet: string): Promise<HttpResponse<string>> {
        return this.getThemeCssRequest(this.getUrlPath(currentStylesheet));
    }

    private getThemeCssRequest(url: string): Promise<HttpResponse<string>> {
        return lastValueFrom(this.http.get<string>(url, { responseType: 'text' }));
    }

    /**
     * Function which detects if user want to use relative/absolute path or use stored theme id.
     * If provided string is URL, use it as absolute path.
     * We are storing themes only with name, without `.css`.
     * Local file have to includes `.css` to work, so we are checking it and use as absolute path.
     * Otherwise it will be a stored theme id.
     * @param currentStylesheet string
     * @returns string
     */
    public getUrlPath(currentStylesheet: string): string {
        // absolute
        if (isUrl(currentStylesheet)) return currentStylesheet;
        // relative
        if (currentStylesheet.includes('.css')) return currentStylesheet;
        // stored theme id
        return `${this.baseUrl}${currentStylesheet}`;
    }
}
